import axios from "./axios";

const submitGuardianRequest = async (formData: FormData) => {
  try {
    const endpoint = "/user/become-keeper";
    const response = await axios.post(endpoint, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

const getGuardiansPaginated = async (
  page = 1,
  limit = 10,
  name = "",
  status = "",
) => {
  try {
    const endpoint = `/user/keepers?page=${page}&limit=${limit}&name=${name}&status=${status}`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

const updateGuardianStatus = async (id: number, status: string) => {
  try {
    const endpoint = `/user/keepers/${id}/status`;
    const response = await axios.patch(endpoint, { status });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

const updateGuardianExpiry = async (id: number, expiry: string) => {
  try {
    const endpoint = `/user/keepers/${id}/expiry`;
    const response = await axios.patch(endpoint, { expiry });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

const deleteGuardianRequest = async (id: number) => {
  try {
    const endpoint = `/user/keepers/${id}`;
    const response = await axios.delete(endpoint);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

const guardianService = {

  submitGuardianRequest,
  getGuardiansPaginated,
  updateGuardianStatus,
  updateGuardianExpiry,
  deleteGuardianRequest,
};

export default guardianService;
